if (!customElements.get('hero-carousel')) {
  customElements.define(
    'hero-carousel',
    class HeroCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hero-carousel__slide'));
        this.dots = Array.from(this.querySelectorAll('.hero-carousel__dot'));
        this.fills = Array.from(this.querySelectorAll('.hero-carousel__dot-fill'));
        this.prevButton = this.querySelector('.hero-carousel__arrow--prev');
        this.nextButton = this.querySelector('.hero-carousel__arrow--next');

        this.current = 0;
        this.autoplayDelay = (parseFloat(this.dataset.autoplaySeconds) || 6) * 1000;
        this.userStopped = false;
        this.hovering = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.slides.length < 2) return;

        this.prevButton?.addEventListener('click', () => this.userNavigate(this.current - 1));
        this.nextButton?.addEventListener('click', () => this.userNavigate(this.current + 1));
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.userNavigate(index));
        });

        // The active slide's progress bar drives autoplay directly: when its
        // fill animation finishes (i.e. the indicator reaches the end of the
        // interval), advance to the next slide. Only the active bar ever has
        // a running animation, so this fires exactly once per cycle.
        this.fills.forEach((fill) => {
          fill.addEventListener('animationend', () => this.onFillComplete());
        });

        this.addEventListener('mouseenter', () => {
          this.hovering = true;
          this.classList.add('is-paused');
        });
        this.addEventListener('mouseleave', () => {
          this.hovering = false;
          this.classList.remove('is-paused');
        });

        this.addEventListener('touchstart', (event) => this.onTouchStart(event), { passive: true });
        this.addEventListener('touchend', (event) => this.onTouchEnd(event), { passive: true });

        this.goTo(0);
      }

      goTo(index) {
        const total = this.slides.length;
        const nextIndex = (index + total) % total;

        this.slides.forEach((slide, i) => {
          const isActive = i === nextIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          if ('inert' in slide) slide.inert = !isActive;
          slide.querySelectorAll('a, button').forEach((el) => {
            if (isActive) {
              el.removeAttribute('tabindex');
            } else {
              el.setAttribute('tabindex', '-1');
            }
          });
        });

        this.dots.forEach((dot, i) => {
          const isActive = i === nextIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');

          const fill = this.fills[i];
          if (!fill) return;
          fill.classList.remove('is-filling');
          fill.style.width = '';
          // Force reflow so re-adding the class restarts the animation on the same element.
          void fill.offsetWidth;
          if (isActive && !this.userStopped && !this.reducedMotion) {
            fill.style.animationDuration = `${this.autoplayDelay}ms`;
            fill.classList.add('is-filling');
          } else if (isActive) {
            fill.style.width = '100%';
          }
        });

        this.current = nextIndex;
      }

      onFillComplete() {
        if (this.userStopped || this.hovering) return;
        this.goTo(this.current + 1);
      }

      userNavigate(index) {
        this.userStopped = true;
        this.goTo(index);
      }

      onTouchStart(event) {
        this.touchStartX = event.changedTouches[0].clientX;
      }

      onTouchEnd(event) {
        if (this.touchStartX === undefined) return;
        const deltaX = event.changedTouches[0].clientX - this.touchStartX;
        const threshold = 50;
        if (Math.abs(deltaX) < threshold) return;
        if (deltaX < 0) {
          this.userNavigate(this.current + 1);
        } else {
          this.userNavigate(this.current - 1);
        }
      }
    }
  );
}
